// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2641":"7c98f1f9","7851":"5dd0a2df","8847":"92e7ea31"}[chunkId] + ".css";
};